import { ContactCardProps } from '../typings'

import { Theme } from '@mui/material/styles'

export const getStyles = (props: ContactCardProps) => ({
  root: {
    backgroundColor: props.isPrimaryContact
      ? '#f4f8fa'
      : (theme: Theme) => theme.palette.common.white,
    border: 'solid 1px #dedede',
    boxShadow: '0 2px 6px 0 #dddddd',
    marginBottom: (theme: Theme) => theme.spacing(2),
    maxWidth: props.maxWidth ? props.maxWidth : 'auto',
    padding: (theme: Theme) => theme.spacing(2),
  },

  arrow: {
    marginBottom: (theme: Theme) => theme.spacing(0.4),
    marginLeft: (theme: Theme) => theme.spacing(0.6),
    verticalAlign: 'middle',
  },

  billToServiceLocationLabel: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
  },

  dataItem: {
    color: (theme: Theme) => theme.palette.text.primary,
    marginLeft: (theme: Theme) => theme.spacing(3.2),
  },

  dataItemContainer: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontSize: '14px',
    '&>div:not(:last-child)': {
      marginRight: (theme: Theme) => theme.spacing(5.6),
    },
  },

  overflowDetector: {
    marginTop: (theme: Theme) => theme.spacing(2),
  },

  fieldName: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro Semibold',
  },

  locationLink: {
    fontSize: '14px',
  },

  makePrimaryLink: {
    marginTop: (theme: Theme) => theme.spacing(0),
  },

  moreInfoLink: {
    color: '#005aa3',
    fontSize: '14px',
    transition: 'opacity 0.5s',
  },

  name: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '20px',
    fontWeight: 'bold',
  },

  primaryContactTitle: {
    fontFamily: 'Source Sans Pro SemiBold',
    marginBottom: (theme: Theme) => theme.spacing(1),
  },

  primaryContactLabel: {
    color: '#31373d',
    fontFamily: 'Source Sans Pro',
    lineHeight: '28px',
    whiteSpace: 'nowrap',
  },

  primaryContactFormLabel: {
    margin: (theme: Theme) =>
      `${theme.spacing(-0.8)} 0 ${theme.spacing(-0.8)} 0`,
    whiteSpace: 'nowrap',
  },

  title: {
    color: '#31373d',
    fontSize: '14px',
    fontWeight: 600,
  },

  viewMoreLink: {
    color: '#005aa3',
    fontSize: '14px',
  },
})
